import { render, staticRenderFns } from "./SchemaPropertyEditor.vue?vue&type=template&id=26ad2550&scoped=true&"
import script from "./SchemaPropertyEditor.vue?vue&type=script&lang=js&"
export * from "./SchemaPropertyEditor.vue?vue&type=script&lang=js&"
import style0 from "./SchemaPropertyEditor.vue?vue&type=style&index=0&id=26ad2550&scoped=true&lang=css&"
import style1 from "./SchemaPropertyEditor.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ad2550",
  null
  
)

export default component.exports